<template>
    <div class="cooperation">
        <div class="item wow animate__animated animate__bounceInRight" :data-wow-delay ="item.time+'s'" v-for="(item,index) in list" :key="index">
            <img :src="item.img" alt="">
        </div>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
export default {
    data(){
        return{
            list:[
                {
                    time:0.2,
                    img:require('../../../../public/images/yinhang/yh1.png'),
                },{
                    time:0.4,
                    img:require('../../../../public/images/yinhang/yh2.png'),
                },{
                    time:0.6,
                    img:require('../../../../public/images/yinhang/yh3.jpg'),
                },{
                    time:0.8,
                    img:require('../../../../public/images/yinhang/yh4.png'),
                },{
                    time:1.0,
                    img:require('../../../../public/images/yinhang/yh5.png'),
                },{
                    time:1.2,
                    img:require('../../../../public/images/yinhang/yh6.png'),
                },{
                    time:1.4,
                    img:require('../../../../public/images/yinhang/yh7.png'),
                },{
                    time:1.6,
                    img:require('../../../../public/images/yinhang/yh8.png'),
                },{
                    time:1.8,
                    img:require('../../../../public/images/yinhang/yh9.png'),
                },{
                    time:2.0,
                    img:require('../../../../public/images/yinhang/yh10.png'),
                },{
                    time:2.2,
                    img:require('../../../../public/images/yinhang/yh11.png'),
                },{
                    time:2.4,
                    img:require('../../../../public/images/yinhang/yh12.png'),
                },
            ],
        }
    },
    watch:{
        
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    created(){
        
    },
    methods:{
        
    }
}
</script>
<style scoped  lang="scss">
    .cooperation{
        background: #EDEDED;height: 45rem;display: flex;
        flex-wrap: wrap;
        padding-top: 1rem;
        padding-right: 1rem;
        .item{background: #fff;height: 14rem;width: 22.8rem; margin-left: 1rem;margin-bottom: 1rem; border-radius: 0.4rem;display: flex;align-items: center;justify-content: center;}
    }
</style>